import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { renderNotification } from './render'
import { FeLogger } from '@/addons/monitoring'
import store from '@/store'
import { ConfigActions } from '@/store/configs-store'

/**
 * Send Firebase config to service worker
 */
const sendConfigToServiceWorker = (config) => {
  return new Promise<void>((resolve, reject) => {
    const messageChannel = new MessageChannel()

    messageChannel.port1.onmessage = (event) => {
      if (event.data.success) {
        FeLogger.info('[Push notifications web] service worker initialized:')
        resolve()
      } else {
        reject(new Error('Failed to initialize Firebase in service worker'))
      }
    }

    navigator?.serviceWorker?.controller?.postMessage(
      {
        type: 'INIT_FIREBASE',
        config: config,
      },
      [messageChannel.port2],
    )
  })
}

export const initWebPushNotification = async () => {
  // TODO: get config from database
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DB_URL,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  }

  // FeLogger.info(firebaseConfig)

  if (Object.values(firebaseConfig).filter((el) => !el).length === 0) {
    FeLogger.info(
      '[Push notifications web] Firebase config is valid, initializing messaging',
    )

    if ('serviceWorker' in navigator) {
      const swName = 'firebase-messaging-sw.js'
      await navigator.serviceWorker.register(swName)
      await navigator.serviceWorker.ready
      await sendConfigToServiceWorker(firebaseConfig)
    }

    const app = initializeApp(firebaseConfig)
    const messaging = getMessaging(app)

    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        getToken(messaging)
          .then((currentToken) => {
            FeLogger.info(
              '[Push notifications web] Firebase token received:',
              currentToken,
            )
            if (currentToken) {
              store
                .dispatch(ConfigActions.SET_FCM_TOKEN, currentToken)
                .catch((e) =>
                  FeLogger.error(
                    '[Push notifications web] Failed to save FCM token in state',
                    e,
                  ),
                )
            }
          })
          .catch((err) => {
            FeLogger.error('[Push notifications web] getToken error', err)
          })
      } else {
        FeLogger.warn('Unable to get permission to notify.')
      }
    })

    onMessage(messaging, (payload) => {
      renderNotification(payload)
    })

    // const channel = new BroadcastChannel('notification_broadcast_channel');
    // channel.onmessage = (event) => {
    //   // console.log('Broadcast message received:', event.data);
    //   FeLogger.info(event.data)
    //   // Update the DOM or trigger other actions based on the received message
    // }
  }
}
